import { render } from "./testimonials.vue?vue&type=template&id=296287c5&scoped=true"
import script from "./testimonials.vue?vue&type=script&lang=js"
export * from "./testimonials.vue?vue&type=script&lang=js"

import "./testimonials.vue?vue&type=style&index=0&id=296287c5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296287c5"]])

export default __exports__